import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { SELECTORS } from '@oneaudi/stck-store';
import { formatCount } from '../../../utils';
import { useServicesContext } from '../../../context';
import { useScsUrlParts } from '../../../hooks';
import { useI18n } from '@oneaudi/i18n-context';
import { FilterOverlayFooterContainer, StyledResultsButtonWrapper, StyledDeleteFiltersButtonWrapper, } from '../styles/FilterOverlay.styles';
import { trackClicks, trackRemoveAllFilters } from '../tracking';
import { TextButton } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_MD, ThemeProvider } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { resetNumVehiclesOnPLP } from '../../utils';
export const FilterOverlayFooter = ({ closeOverlay, clearAllFilters, }) => {
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const { isUsedCarMkt } = useScsUrlParts();
    const resultsButtonLabel = useI18n({
        id: `nemo.sc.filter.resultsButton`,
        defaultMessage: '',
    });
    const deleteFiltersLabel = useI18n({
        id: `nemo.ui.sc.filter-options.reset.label`,
        defaultMessage: '',
    });
    const localeService = useServicesContext().getAdditionalService('gfa:locale-service');
    const locale = `${localeService.language}-${localeService.countryCode}`;
    const totalResults = useSelector((state) => SELECTORS.VEHICLES.getTotalCountState(state));
    const formattedResultsCount = formatCount(totalResults, locale);
    const allSelectedFilters = useSelector((state) => SELECTORS.FILTERS.getSelectedFiltersMap(state));
    const [isLoadingNewFilterData, setIsLoadingNewFilterData] = useState(false);
    useSelector((state) => {
        const getLoadingStateFromRedux = SELECTORS.UI.getLoadingState(state);
        if (getLoadingStateFromRedux !== isLoadingNewFilterData) {
            setIsLoadingNewFilterData(getLoadingStateFromRedux);
        }
    });
    const handleResultsButtonClick = () => {
        closeOverlay();
        const trackingEventName = 'vtp filter - click to show results';
        trackClicks(trackingService, trackingEventName, `${formattedResultsCount} ${resultsButtonLabel}`, 'button', '', false);
    };
    const handleDeleteButtonClick = () => {
        const trackingRelatedFilters = [];
        [...allSelectedFilters.values()].forEach((filter) => {
            const relatedFilter = { id: filter.id, values: filter.values || [] };
            trackingRelatedFilters.push(relatedFilter);
        });
        resetNumVehiclesOnPLP();
        trackRemoveAllFilters(trackingService, 'vtp filter - remove all filter', 'text link', deleteFiltersLabel, trackingRelatedFilters, totalResults, isUsedCarMkt);
        clearAllFilters();
    };
    const resultButton = useMemo(() => {
        return (React.createElement(ThemeProvider, { theme: { name: 'dark' } },
            React.createElement(StyledTextButton, { "data-testid": "ResultButton", variant: "primary", size: "md", onClick: handleResultsButtonClick, isLoading: isLoadingNewFilterData, "data-tracking-exclude": true }, `${formattedResultsCount} ${resultsButtonLabel}`)));
    }, [isLoadingNewFilterData]);
    return (React.createElement(FilterOverlayFooterContainer, null,
        React.createElement(StyledResultsButtonWrapper, null, resultButton),
        React.createElement(StyledDeleteFiltersButtonWrapper, null,
            React.createElement(ThemeProvider, { theme: { name: 'dark' } },
                React.createElement(TextButton, { variant: "tertiary", icon: "erase", size: "sm", iconPosition: "leading", onClick: handleDeleteButtonClick }, deleteFiltersLabel)))));
};
export default FilterOverlayFooter;
export const StyledTextButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  margin-top: var(--spacing-relative-md);
  margin-bottom: var(--spacing-relative-md);
  width: 100%;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: unset;
  }
`;
